<!--
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2024-01-12 10:25:15
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <NuxtLayout>
    <!-- ！！！NuxtPage 无法对路由使用keepalive。这里改成router-view -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="KeepAliveList">
        <Suspense @pending="suspensePending" @resolve="suspenseResolve">
          <component :is="Component" id="main-box" class="main" :scrollTop="scrollTop" />
        </Suspense>
      </keep-alive>
    </router-view>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import { ImageMask } from '@/assets/js/imagemask';
import { useStore } from '@/store';

/** useHead link 项：href 为函数以跟随 route 变化，与 Unhead Link 运行时兼容 */
interface AppHeadLink {
  rel: string;
  href: () => string;
  media?: string;
}

const store = useStore();
const nuxtApp = useNuxtApp();
const route = useRoute();

const KEEP_AND_REMEMBER: readonly string[] = [
  'NeonCollection',
  'BlueLightCollection',
  'BlueLightCollectionView',
  'ProgressiveCollection',
  'ProgressiveCollectionView',
  'PhotochromicCollection',
  'PhotochromicCollectionView',
  'HalfFrame',
  'EcoCollection',
  'EcoCollectionView',
  'TransitionsCollection',
  'TransitionsCollectionView',
  'FlashSale',
  'Bfcm2025',
  'CustomTheme',
  'CustomThemeView',
  'SpecialOffers',
  'newEyeGlasses',
  'newEyeGlassesView',
  'CustomNewEyeGlasses',
  'CustomNewEyeGlassesView',
  'Studio',
  'Ambassadors',
  'Lookbook',
  'Represents',
  'TrendBookIndex',
  'TrendBookReusedPage',
  'TrendBookEssentials',
  'TrendBookBohemian',
  'TrendBookEyewearMoments',
  'TrendBookSleaze',
  'TrendBookFestivalStyleEyewear',
  'TrendBookFestivalGudie',
  'FitGuide',
  'Directory',
  'TrendBookRaverTypes',
  'TrendBookPsychedelicRaver',
  'TrendBook90sClub',
  'TrendBookTiedye',
  'FestivalQuiz',
  'EvewearSummerSale2025',
  'TrendBookFestivalEyecare',
  'TrendBookLeaveNoTrace',
  'TrendBookMusicRoadTrip',
  'TrendBookSummerRetroEyewear',
  'TrendBookFestivalPhotographyGuide',
  'BuyGet',
  'Anniversary2025',
  'TomBogoCollection',
  'Clearance',
  'BloodyOpiumCollection',
  'FsaHsaGlasses',
  'ValentinesDayEyewear',
  'ColorTint',
  'VacationSunglasses',
  'MotoBohoCollection',
];
// keep-alive 的组件名称（需可变数组类型以符合 keep-alive 的 include 类型）
const KeepAliveList: string[] = [
  'HomePage',
  'GoodsList',
  'Beauty',
  'StudentDiscount',
  'SearchResult',
  'AuroraCollection',
  ...KEEP_AND_REMEMBER,
];
const RememberScrollList: readonly string[] = [
  'index',
  'goodsList',
  'account',
  'search',
  ...KEEP_AND_REMEMBER,
]; // 需要记住滚动位置的页面路由名称（需keep-alive加页面内自定义实现）
const { SET_SCROLLHASH } = store;

const runtimeConfig2 = useRuntimeConfig();
const seoTitle = 'Vooglam | Unique & Designer Eyewear to Show Off Your Vision';
const seoDescription =
  "Eyewear as unique as you are. Discover Vooglam's designer frames, crafted to empower your distinctive style. Find your perfect pair and let the world see you.";
const seoImage = 'https://cdn.vooglam.com/json-value/17c02f159d933377643250d0bcf83de7.jpg';

useSeoMeta({
  title: seoTitle,
  keywords: 'vooglam eyewear, unique eyewear, designer eyewear',
  description: seoDescription,
  robots:
    runtimeConfig2.public.VUE_APP_MODE == 'production' ||
    runtimeConfig2.public.VUE_APP_MODE == 'local'
      ? 'all,max-image-preview:large'
      : 'noindex,nofollow,max-image-preview:large',
  fbAppId: '246397316194657',
  ogSiteName: 'Vooglam',
  ogType: 'website',
  ogUrl: `https://www.vooglam.com${route.path}`,
  ogTitle: seoTitle,
  ogDescription: seoDescription,
  ogImage: seoImage,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogImageAlt: 'Vooglam Stylish Eyewear',
  twitterCard: 'summary_large_image',
  twitterSite: '@Vooglam',
});
// 这里在路由跳转时不会自动更新。当前结果可以接受，可后期优化。
const linkArr: AppHeadLink[] = [
  {
    rel: 'canonical',
    href: () => `https://www.vooglam.com${route.path}`,
  },
];
console.log('触发构建');
if (route.name !== 'goodsList') {
  linkArr.push({
    rel: 'alternate',
    media: 'only screen and (max-width: 640px)',
    href: () => `https://m.vooglam.com${route.path}`,
  });
}
// Unhead Link 类型含 data-* 等索引，本项目仅用 rel/href/media，运行时兼容
useHead({
  // @ts-expect-error AppHeadLink[] 与 Link[] 结构兼容，href 为函数以随 route 更新
  link: linkArr,
  meta: [
    // 添加自定义的 og:logo meta 标签
    {
      property: 'og:logo',
      content: 'https://cdn.vooglam.com/json-value/2a6bbed9c52750215aec7cdfe09df42e.png',
    },
  ],
});

const scrollTop = 0; // 滚动距离，从scroll组件抛出，供子组件使用

// --- suspense pending 时出loading
const suspensePending = (): void => {
  nuxtApp.$loadingShow();
};
// 处理非keepalive组件的滚动（默认置顶）
const suspenseResolve = (): void => {
  console.log('suspenseResolve');
  nuxtApp.$loadingHide();
  // 除keepalive页面外，其他页面都进入置顶
  const shouldScrollTop = !RememberScrollList.includes(route?.name ?? '') || store.isRouterPush;
  if (shouldScrollTop) {
    nextTick(() => {
      SET_SCROLLHASH({
        top: 0,
        flag: true,
        behavior: 'instant',
      });
    });
  }
};

// 统一记录落地页路由名称，各个页面都可使用
const landingPageName = useState<string>('landingPageName', () => '');
if (process.server) {
  landingPageName.value = route.name ?? '';
}

// 隐藏秘钥
onMounted(() => {
  const mask = new ImageMask({
    debug: false, // 是否开启调试模式
    charSize: 16, // 字符的字节位数，默认为16，即字符最大值为0xFFFF
    mixCount: 2, // 隐写数据要混合到图片颜色值里的最低位数，值范围在1-5，默认为2，如果大于3，则图片会失真很严重
    lengthSize: 24, // 数据长度值的占用字节位数，默认为24，也即数据长度最大值为16777215
  });
  const runtimeConfig = useRuntimeConfig();
  let loadImageNum = 0;
  function loadImage() {
    const image = new Image();
    if (['local', 'dev', 'test'].includes(runtimeConfig.public.VUE_APP_MODE as string)) {
      image.src =
        'data:image/png;base64,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';
    } else {
      image.src =
        'data:image/png;base64,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';
    }
    image.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(image, 0, 0);
        const message = mask.revealText(canvas);
        document.documentElement.encrypt_info = message;
      }
    };
    image.onerror = function () {
      if (loadImageNum > 30) {
        store.collectError({ ua: navigator.userAgent, type: 'signature-loadImage' });
        return;
      }
      loadImageNum++;
      loadImage();
    };
  }
  loadImage();
});

// -----------神策埋点-----------
function sendLandingPage(): void {
  try {
    const sdEventName = 'Frontend_LandingPage_View';
    const navEntry = performance.getEntriesByType('navigation')[0];
    const referrer =
      navEntry && 'type' in navEntry && navEntry.type === 'navigate' ? document.referrer || '' : '';
    const sdEventParams = {
      page_name: route.meta.cnName ?? route.name,
      url_path: route.path,
      referrer,
    };
    window.voo_sensors?.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
}
onMounted(() => {
  sendLandingPage();
});
</script>
<!-- 此文件不写样式。如需写样式请写到 default.vue. 原因：避免样式打包进HTML文档中 -->
